import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'box',
    templateUrl: './box.component.html',
    styleUrls: ['./box.component.scss'],
    standalone: false
})
export class BoxComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
